import deepmerge from 'deepmerge'

import initialBaseTheme from './base'

const createTheme = (overrides) => {
  const base = deepmerge(
    initialBaseTheme,
    typeof overrides === 'function' ? overrides(initialBaseTheme) : overrides
  )
  return deepmerge(base, {
    shadows: base.utils.createShadows(base.colors.shadow),
    colors: {
      ...base.utils.createColorVariations(base.colors),
    },
  })
}

export default createTheme
